import { Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TOnlineRiskManagementDataTableData = {
  primaryKey: string | number,
  transactionCode: string,
  transactionMin: string,
  transactionMax: string,
  limitAmount: string,
  exceptAmount: string,
  limitNbr: string,
  currentAuthorizationAmount: string,
  currentAuthorizationNbr: string,
  currentUsageAmount: string,
  currentUsageNbr: string,
  availableAmount: string,
  availableNbr: string,
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TOnlineRiskManagementDataTableData>();

export function getOnlineRiskManagementDataTableColumns({ isLoading }: Props) {
  return [

    columnHelper.accessor('transactionCode', {
      id: 'transactionCode',
      header: 'Code Transaction',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('transactionMin', {
      id: 'transactionMin',
      header: 'Tran. Min',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('transactionMax', {
      id: 'transactionMax',
      header: 'Tran. Min',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('limitAmount', {
      id: 'limitAmount',
      header: 'Mnt. Limite',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>;
      },
    }),
        
    columnHelper.accessor('exceptAmount', {
      id: 'exceptAmount',
      header: 'Mnt. Excep',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>;
      },
    }),

    columnHelper.accessor('currentAuthorizationAmount', {
      id: 'currentAuthorizationAmount',
      header: 'Mnt.Aut.Cour.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>;
      },
    }),

    columnHelper.accessor('currentAuthorizationNbr', {
      id: 'currentAuthorizationNbr',
      header: 'Nbr.Aut.Cour.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>;
      },
    }),

    columnHelper.accessor('currentUsageAmount', {
      id: 'currentUsageAmount',
      header: 'Mtn.Usag.Cour.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>;
      },
    }),

    columnHelper.accessor('currentUsageNbr', {
      id: 'currentUsageNbr',
      header: 'Nbr.Usag.Cour.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>;
      },
    }),

    columnHelper.accessor('availableAmount', {
      id: 'availableAmount',
      header: 'Mnt.Dispo.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>;
      },
    }),

    columnHelper.accessor('availableNbr', {
      id: 'availableNbr',
      header: 'Nbr.Dispo.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>;
      },
    }),

  ];
}
